import Link from 'next/link';
import { motion } from 'framer-motion';
import { styled } from 'styled-components';
export const TabContainer = styled(motion.div).withConfig({
  displayName: "CategoryMenuMobilestyle__TabContainer",
  componentId: "sc-4cg3th-0"
})(["", ""], {
  "marginBottom": "1.5rem",
  "display": "flex",
  "flexDirection": "row",
  "flexWrap": "wrap",
  "gap": "0.5rem"
});
export const ButtonContainer = styled(motion.div).withConfig({
  displayName: "CategoryMenuMobilestyle__ButtonContainer",
  componentId: "sc-4cg3th-1"
})(["", ""], {
  "marginTop": "3.5rem",
  "display": "flex",
  "justifyContent": "center"
});
export const CustomButton = styled(Link).withConfig({
  displayName: "CategoryMenuMobilestyle__CustomButton",
  componentId: "sc-4cg3th-2"
})(["", " &:hover{", "}"], {
  "display": "flex",
  "minHeight": "3rem",
  "minWidth": "120px",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(238 132 60 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.375rem",
  "paddingBottom": "0.375rem",
  "fontSize": "28px",
  "fontWeight": "500",
  "lineHeight": "30px",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
});